import React, {useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import DocumentPreview from '../../../_common/components/DocumentPreview';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ModalContent from '../../../_common/components/ModalContent';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import ButtonAction from '../../../_common/components/ButtonAction';
import styles from '../../styles/styles.module.scss';
import {buttonCancel, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupPreviewDocument = ({content}) => {
  const {adminPermissionsLevel} = useSelector(
    (state) => ({adminPermissionsLevel: state.auth.adminPermissionsLevel,}), shallowEqual
  );
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const disabledCondition = !can(T.FULL, S.INSPECTIONS_PAGE)
    || !content.finalPDFFileID
    || adminPermissionsLevel === 3
    || Boolean(!adminPermissionsLevel);

  return (
    <>
      <ButtonAction
        iconButtonType={'error'}
        variant={'icon'}
        label={<img src={toAbsoluteUrl('media/common/Zoom-plus_red.svg')} alt={'icon'} className="w-20px h-20px"/>}
        title={TTS.PREVIEW_SHUMA}
        onClick={() => handleShowModal()}
        disabled={disabledCondition}
        customClassnames={'my-1'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'xl'} customClassnames={'pt-0'}>
        <ModalContent customClassnames={styles.contentContainer}>
          <div className={styles.documentViewPort}>
            <div className={styles.iframeContainerWrapper}>
              <div className={styles.iframeContainer}>
                <DocumentPreview
                  shumaID={content.shumaID}
                  fileID={content.finalPDFFileID}
                  close={handleCloseModal}
                />
              </div>
            </div>
          </div>
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            label={'סגירה'}
            onClick={handleCloseModal}
            customClassnames={buttonCancel}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupPreviewDocument;